



































import { Component, Mixins } from "vue-property-decorator";
import { CacheableComponent } from "../../../../../../base/components/system";
import {
  ModelEditableMixin,
  TabContainableMixin,
} from "../../../../../../base/components/system/mixins";
import { TabSelector } from "../../../../../../base/components/system/selectors";
import { default as FormatPropertyLimitReadingLimitsEditTool } from "./FormatPropertyLimitReadingLimitsEditTool.vue";
import { default as FormatPropertyLimitWritingLimitsEditTool } from "./FormatPropertyLimitWritingLimitsEditTool.vue";
import { default as FormatPropertyLimitDeleteLimitsEditTool } from "./FormatPropertyLimitDeleteLimitsEditTool.vue";

interface ITabDefinition {
  name: string;
  title: string;
  description: string;
}

@Component({
  components: {
    CacheableComponent,
    TabSelector,
    FormatPropertyLimitReadingLimitsEditTool,
    FormatPropertyLimitWritingLimitsEditTool,
    FormatPropertyLimitDeleteLimitsEditTool,
  },
})
export default class FormatPropertyLimitEditTool extends Mixins(ModelEditableMixin, TabContainableMixin) {
  static readonly Tabs = {
    readingLimits: {
      name: "readingLimits",
      title: "閲覧制限",
      description: "閲覧制限を編集します。",
    },
    writingLimits: {
      name: "writingLimits",
      title: "記載制限",
      description: "記載制限を編集します。",
    },
    deleteLimits: {
      name: "deleteLimits",
      title: "削除制限",
      description: "削除制限を編集します。",
    },
  };

  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly readingLimitsTab: ITabDefinition = FormatPropertyLimitEditTool.Tabs.readingLimits;
  readonly writingLimitsTab: ITabDefinition = FormatPropertyLimitEditTool.Tabs.writingLimits;
  readonly deleteLimitsTab: ITabDefinition = FormatPropertyLimitEditTool.Tabs.deleteLimits;

  created(): void {
    this.initializeTabs();
  }

  initializeTabs(): void {
    this.tabs = [
      this.readingLimitsTab,
      this.writingLimitsTab,
      this.deleteLimitsTab,
    ];
    this.selectedTab = this.readingLimitsTab;
  }
}
